<div fxLayoutAlign="center stretch" fxLayout="row" class="status-banner {{ status.color }}">
  <mat-label class="margin-bottom-sm margin-top-sm" fxLayoutAlign="center center">
    <mat-icon fxFlex *ngIf="status.svgIcon" [svgIcon]="status.svgIcon" class="margin-right-sm"></mat-icon>
    <div>{{ status.message }}</div>
  </mat-label>
</div>
